import { gql } from "@apollo/client";
import {
  ITEMBASICSFRAGMENT,
  FEATUREDIMAGETHUMBNAILFRAGMENT,
} from "@geerly/shared";

import { SEOFRAGMENT } from "seo-modules/PageSeo";

export const TERMFRAGMENT = gql`
  fragment TermFragment on TermNode {
    id
    databaseId
    name
    slug
  }
`;
export const ATHLETE_BASICS_FRAGMENT = gql`
  fragment AthleteBasicsFragment on Athlete {
    ...ItemBasicsFragment
    ...SeoFragment
    ...FeaturedImageThumbnailFragment
    athleteDetails {
      isRestricted
      fullName
      firstName
      lastName
      description
      city {
        name
      }
      country {
        name
        slug
        id
      }
      profileImages {
        profile
        profileMedium
        coverImage {
          sourceUrl(size: LARGE)
          id
        }
      }
      spotifyLink
      socialLinks {
        facebook
        instagram
        strava
        twitter
        youtube
        tiktok
      }
      sponsors {
        id
        uri
        slug
        name
        featuredImage {
          node {
            id
            sourceUrl(size: THUMBNAIL)
          }
        }
      }
      website
      donate
      state {
        ...ItemBasicsFragment
      }
      athleteType {
        ...ItemBasicsFragment
        slug
      }
      reviewerChannel {
        ... on Publisher {
          id
          slug
          title
        }
      }
    }
    integration {
      platformId
      accountAuthorised
      integrationProfileUrl
      isSynched
      integrationPlatform {
        ... on Integration {
          id
          title
          slug
        }
      }
    }
  }
  ${ITEMBASICSFRAGMENT}
  ${SEOFRAGMENT}
  ${FEATUREDIMAGETHUMBNAILFRAGMENT}
`;
export const MEMBERFRAGMENT = gql`
  fragment MemberFragment on User {
    id
    name
    description
    position
    twitter
    youTube
    facebook
    instagram
    strava
    stravaId
    userDetails {
      linkedAthlete {
        ...AthleteBasicsFragment
      }
    }
    avatar(size: 150) {
      url
    }
  }
  ${ATHLETE_BASICS_FRAGMENT}
`;

export const AUTHORFRAGMENT = gql`
  fragment AuthorFragment on NodeWithAuthor {
    author {
      node {
        ...MemberFragment
      }
    }
  }
`;
